module.exports = __webpack_public_path__ + "f1aa385e6ccdc3496f1d1a45db8ff064.png";